import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
  },
  {
    path: '*',
    name: '404*',
    component: require('@/views/PageNotFound.vue').default
  }
]

const { routes: clientRoutes } = require('./routes/client')
const { routes: adminRoutes } = require('./routes/admin')

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...adminRoutes,
    ...clientRoutes,
    ...routes
  ]
})

router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const adminPath = to.path.split('/')[1] === 'admin'
  // console.log(user)
  // console.log(to)
  const base = adminPath
    ? 'admin'
    : to.path.split('/').slice(1, 3).join('/')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // console.log('block 1')
    if (localStorage.getItem('jwtToken') == null) {
      // console.log('block 1 sub 1')
      next({
        name: adminPath ? 'AdminLogin' : 'ClientLogin',
        params: { nextUrl: to.fullPath }
      })
    } else {
      // console.log('block 1 sub 2')
      if (to.matched.some(record => record.meta.isAdmin)) {
        // console.log('block 1 sub 2 sub 1')
        if (user && user.isAdmin) {
          // console.log('block 1 sub 2 sub 1 sub 1')
          next()
        } else if (user) {
          // console.log('block 1 sub 2 sub 1 sub 2')
          next({ name: 'ClientDashboard', params: { slug: store.state.slug } })
        } else {
          // console.log('block 1 sub 2 sub 1 sub 3')
          next({ name: 'ClientLogin', params: { slug: store.state.slug } })
        }
      } else {
        // console.log('block 1 sub 2 sub 2')
        if (user.isAdmin) {
          // console.log('block 1 sub 2 sub 2 sub 1')
          next({ name: 'AdminDashboard' })
        } else {
          // console.log('block 1 sub 2 sub 2 sub 2')
          next()
        }
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    // console.log('block 2')
    if (localStorage.getItem('jwtToken') == null) {
      // console.log('block 2 sub 1')
      next()
    } else {
      // console.log('block 2 sub 2')
      next({ path: `/${base}/dashboard` })
    }
  } else {
    // console.log('block 3')
    if (user) {
      // console.log('block 3 sub 1')
      if (user.isAdmin) {
        // console.log('block 3 sub 1 sub 1')
        next({ name: 'AdminDashboard' })
      } else {
        next({ name: 'ClientDashboard', params: { slug: store.state.slug } })
      }
    } else {
      // console.log('block 3 sub 2')
      next()
    }
  }
})

export default router
